import { render, staticRenderFns } from "./VipVideo.vue?vue&type=template&id=2a4dae0c&scoped=true&"
import script from "./VipVideo.vue?vue&type=script&lang=ts&"
export * from "./VipVideo.vue?vue&type=script&lang=ts&"
import style0 from "./VipVideo.vue?vue&type=style&index=0&id=2a4dae0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4dae0c",
  null
  
)

export default component.exports